import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";

const SoilTestReportCard = ({ data }) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ border: "1px solid #ccc", borderRadius: "8px", overflow: "hidden" }}
    >
      <Table size="small" aria-label="soil test report table">
        <TableBody>
          {Object.entries(data).map(([key, value]) => (
            <TableRow
              key={key}
              sx={{
                borderBottom: "1px solid #ddd", // Border between rows
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{ py: 1, px: 1, fontSize: "1rem" }}
              >
                <strong>{key}</strong>: {value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SoilTestReportCard;
